import Vue from 'vue'
import Api from '@/services/Api'
import {notificarAdvertencia} from '@/utils'

export default {
    login(params) {
        return Api().post(
            'auth/token/', {
                username: params.username,
                password: params.password,
            })
    },
    refreshToken() {
        Api().post(
            'auth/tokenrefresh/', {
                token: localStorage.getItem('token')
            }
        )
    },
    logout() {
        Api().post('auth/token/logout/', {
            token: localStorage.getItem('token')
        }).then(() => {
            localStorage.removeItem("token");
            localStorage.removeItem("secciones_permitidas");
            localStorage.removeItem("vistas_permitidas");
            window.location.reload();
        }).catch(() => {
            localStorage.removeItem("token");
            localStorage.removeItem("secciones_permitidas");
            localStorage.removeItem("vistas_permitidas");
            window.location.reload();
        });
    },
    verifyToken() {
        Api().post('auth/token/verify/', {
            token: localStorage.getItem('token')
        }).catch((error) => {
            if (error.response.status == 403) {
                this.logout();
            }
        })
    },
    validateAccess(){
        Api().post('politicas/validar-acceso/', {
        }).catch((error) => {
            if (error.response.status == 401) {
                console.log("Err: ",error.response.data.usuario);
                notificarAdvertencia(Vue.$toast, error.response.data);
            }
        })
    }
}